import type { ILockableVault, } from "@bracket/types";
import { DateTime, } from "luxon";

export declare type GetVaultLockTimeProps = {
	vault: ILockableVault;
	epoch?: number|null;
	local?: boolean;
	adjust?: string|null;
}


/**
 * Calculates the time when vault withdrawals become locked and cannot be modified
 * 
 * @param {GetVaultLockTimeProps} props - The parameters for calculating lock time
 * @param {Vault | PrismaVault} props.vault - The vault
 * @param {number|null} [props.epoch=null] - The specific epoch to calculate lock time for, if null uses vault's current epoch
 * @param {boolean} [props.local=false] - Whether to return the result in local timezone (true) or UTC (false), defaults to false/UTC
 * @param {string} [props.adjust] - Space-separated time adjustments like "1d 2h 30m 45s"
 * @returns {DateTime} The DateTime when withdrawals become locked, in UTC or local timezone based on local parameter
 * 
 * @remarks
 * This function calculates the lock time by:
 * 1. Getting the claim time using getVaultClaimTime
 * 2. Subtracting twice the expected lock hours to determine when withdrawals become locked
 * 
 * The lock time represents the deadline after which withdrawal requests cannot be submitted
 * or modified for the given epoch.
 */

export const getVaultLockTime = ({
	vault,
	epoch = null,
	local = false,
	adjust = null,
}: GetVaultLockTimeProps) => {

	epoch = epoch ?? vault.epoch;
	const { epoch_duration_days, epoch_offset_hours, launch_date, } = vault;
	const epochShift = vault.symbol === "brUSDC" ? 85 : vault.symbol === "brETH" ? 1 : 0;
	const launch = typeof launch_date === "string" ? DateTime.fromISO(launch_date) : DateTime.fromJSDate(launch_date);

	const lock_time = (
		launch
			.toUTC()
			.set({ hour: 0, minute: epoch_offset_hours * 60, second: 0, millisecond: 0, })
			.plus({ days: epoch * epoch_duration_days, })
			.plus({ days: epochShift, })
	);

	// if(vault.symbol === "brUSDC") {
	// 	console.log(">>>", vault.symbol, lock_time.toLocal().toISO());
	// }

	return local ? lock_time.toLocal() : lock_time;
}
